import { Pipe, PipeTransform } from '@angular/core';
import head from 'lodash-es/head';
import { filterMediaByLabel } from '@df/ui/common/filter-media-by-label-pipe';
import { IProductMediaItem } from '@df/catalog/product/product';

@Pipe({
    name: 'findMediaByLabel',
    standalone: true
})
export class FindMediaByLabellPipe implements PipeTransform {
    transform = findMediaByLabel;
}

export function findMediaByLabel(media: IProductMediaItem[], labels: string | string[], invert: boolean = false): string | undefined {
    return head(filterMediaByLabel(media, labels, invert))?.image;
}
